<template>
    <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2916 18.3564C13.2916 20.4509 11.5938 22.1487 9.49933 22.1487C7.4049 22.1487 5.70703 20.4509 5.70703 18.3564" stroke="#04042B" stroke-width="1.8" stroke-miterlimit="10"/>
        <path d="M9.4984 1.88037C5.68622 1.88037 2.48549 4.75065 2.07174 8.54031L1 18.3565H17.9968L16.9251 8.54031C16.5113 4.75065 13.3106 1.88037 9.4984 1.88037Z" stroke="#04042B" stroke-width="1.8" stroke-miterlimit="10"/>
    </svg>
</template>
